import { render, staticRenderFns } from "./group-work-orders-list-tab.vue?vue&type=template&id=ca8e6870&scoped=true"
import script from "./group-work-orders-list-tab.vue?vue&type=script&lang=js"
export * from "./group-work-orders-list-tab.vue?vue&type=script&lang=js"
import style0 from "./group-work-orders-list-tab.vue?vue&type=style&index=0&id=ca8e6870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca8e6870",
  null
  
)

export default component.exports